import service from '@/store/services/schedule-service';

const state = {
    schedule: {},
    schedulePage: {},
    usersList: {},
    scheduleAdmin: {},
    scheduleAdminPage: {},
    scheduleUpdate: {},
    scheduleMaria: {},
    scheduleMariaTime: {},
    schedulePageMaria: {},
    schedulePageMariaTime: {},
    scheduleAdminMaria: {},
    scheduleAdminPageMaria: {},
    scheduleUpdateMaria: {},
    scheduleMariaPro: {},
    schedulePageMariaPro: {},
    scheduleAdminMariaPro: {},
    scheduleAdminPageMariaPro: {},
    scheduleUpdateMariaPro: {},
    scheduleValidateTime: {},
    scheduleRetoucherSignUpNow: {},
    scheduleMinuteEmploymentMariaPro: {},
    scheduleMassSubscribeMariaPro: {}
};

const mutations = {
    SET_SCHEDULE: (state, schedule) => {
        state.schedule = schedule;
    },
    SET_SCHEDULE_PAGE: (state, schedulePage) => {
        state.schedulePage = schedulePage;
    },
    SET_USERS_LIST: (state, usersList) => {
        state.usersList = usersList;
    },
    SET_SCHEDULE_ADMIN: (state, scheduleAdmin) => {
        state.scheduleAdmin = scheduleAdmin;
    },
    SET_SCHEDULE_ADMIN_PAGE: (state, scheduleAdminPage) => {
        state.scheduleAdminPage = scheduleAdminPage;
    },
    SET_SCHEDULE_UPDATE: (state, scheduleUpdate) => {
        state.scheduleUpdate = scheduleUpdate;
    },
    SET_SCHEDULE_MARIA: (state, scheduleMaria) => {
        state.scheduleMaria = scheduleMaria;
    },
    SET_SCHEDULE_MARIA_TIME: (state, scheduleMariaTime) => {
        state.scheduleMariaTime = scheduleMariaTime;
    },
    SET_SCHEDULE_PAGE_MARIA: (state, schedulePageMaria) => {
        state.schedulePageMaria = schedulePageMaria;
    },
    SET_SCHEDULE_PAGE_MARIA_TIME: (state, schedulePageMariaTime) => {
        state.schedulePageMariaTime = schedulePageMariaTime;
    },
    SET_SCHEDULE_ADMIN_MARIA: (state, scheduleAdminMaria) => {
        state.scheduleAdminMaria = scheduleAdminMaria;
    },
    SET_SCHEDULE_ADMIN_PAGE_MARIA: (state, scheduleAdminPageMaria) => {
        state.scheduleAdminPageMaria = scheduleAdminPageMaria;
    },
    SET_SCHEDULE_UPDATE_MARIA: (state, scheduleUpdateMaria) => {
        state.scheduleUpdateMaria = scheduleUpdateMaria;
    },
    SET_SCHEDULE_MARIA_PRO: (state, scheduleMariaPro) => {
        state.scheduleMariaPro = scheduleMariaPro;
    },
    SET_SCHEDULE_PAGE_MARIA_PRO: (state, schedulePageMariaPro) => {
        state.schedulePageMariaPro = schedulePageMariaPro;
    },
    SET_SCHEDULE_ADMIN_MARIA_PRO: (state, scheduleAdminMariaPro) => {
        state.scheduleAdminMariaPro = scheduleAdminMariaPro;
    },
    SET_SCHEDULE_ADMIN_PAGE_MARIA_PRO: (state, scheduleAdminPageMariaPro) => {
        state.scheduleAdminPageMariaPro = scheduleAdminPageMariaPro;
    },
    SET_SCHEDULE_UPDATE_MARIA_PRO: (state, scheduleUpdateMariaPro) => {
        state.scheduleUpdateMariaPro = scheduleUpdateMariaPro;
    },
    SET_SCHEDULE_MASS_SUBSCRIBE_MARIA_PRO:(state, scheduleMassSubscribeMariaPro) => {
        state.scheduleMassSubscribeMariaPro = scheduleMassSubscribeMariaPro;
    },
    SET_SCHEDULE_VALIDATE_TIME: (state, scheduleValidateTime) => {
        state.scheduleValidateTime = scheduleValidateTime;
    },
    SET_SCHEDULE_RETOUCHER_SIGN_UP_NOW: (state, scheduleRetoucherSignUpNow) => {
        state.scheduleRetoucherSignUpNow = scheduleRetoucherSignUpNow;
    },
    SET_SCHEDULE_MINUTE_EMPLOYMENT_MARIA_PRO: (state, scheduleMinuteEmploymentMariaPro) => {
        state.scheduleMinuteEmploymentMariaPro = scheduleMinuteEmploymentMariaPro;
    }
};

const actions = {
    schedule({commit, dispatch}, params) {
        return service.schedule(params)
            .then(({schedule}) => {
                commit('SET_SCHEDULE', schedule);
            });
    },
    schedulePage({commit, dispatch}, params) {
        return service.schedulePage(params)
            .then(({schedulePage}) => {
                commit('SET_SCHEDULE_PAGE', schedulePage);
            });
    },
    usersList({commit, dispatch}, params) {
        return service.usersList(params).then(({usersList}) => {
            commit('SET_USERS_LIST', usersList);
        });
    },
    scheduleAdmin({commit, dispatch}, params) {
        return service.scheduleAdmin(params).then((scheduleAdmin) => {
            commit('SET_SCHEDULE_ADMIN', scheduleAdmin);
        });
    },
    scheduleAdminPage({commit, dispatch}, params) {
        return service.scheduleAdminPage(params).then((scheduleAdminPage) => {
            commit('SET_SCHEDULE_ADMIN_PAGE', scheduleAdminPage);
        });
    },
    scheduleUpdate({commit, dispatch}, params) {
        return service.scheduleUpdate(params).then((scheduleUpdate) => {
            commit('SET_SCHEDULE_UPDATE', scheduleUpdate);
        });
    },
    scheduleMaria({commit, dispatch}, params) {
        return service.scheduleMaria(params)
            .then(({scheduleMaria}) => {
                commit('SET_SCHEDULE_MARIA', scheduleMaria);
            });
    },
    schedulePageMaria({commit, dispatch}, params) {
        return service.schedulePageMaria(params)
            .then(({schedulePageMaria}) => {
                commit('SET_SCHEDULE_PAGE_MARIA', schedulePageMaria);
            });
    },
    schedulePageMariaTime({commit, dispatch}, params) {
        return service.schedulePageMariaTime(params)
            .then(({schedulePageMariaTime}) => {
                commit('SET_SCHEDULE_PAGE_MARIA_TIME', schedulePageMariaTime);
            });
    },
    scheduleMariaTime({commit, dispatch}, params) {
        return service.scheduleMariaTime(params)
            .then(({scheduleMariaTime}) => {
                commit('SET_SCHEDULE_MARIA_TIME', scheduleMariaTime);
            });
    },
    scheduleAdminMaria({commit, dispatch}, params) {
        return service.scheduleAdminMaria(params).then((scheduleAdminMaria) => {
            commit('SET_SCHEDULE_ADMIN_MARIA', scheduleAdminMaria);
        });
    },
    scheduleAdminPageMaria({commit, dispatch}, params) {
        return service.scheduleAdminPageMaria(params).then((scheduleAdminPageMaria) => {
            commit('SET_SCHEDULE_ADMIN_PAGE_MARIA', scheduleAdminPageMaria);
        });
    },
    scheduleUpdateMaria({commit, dispatch}, params) {
        return service.scheduleUpdateMaria(params).then((scheduleUpdateMaria) => {
            commit('SET_SCHEDULE_UPDATE_MARIA', scheduleUpdateMaria);
        });
    },
    scheduleValidateTime({commit, dispatch}, params) {
        return service.scheduleValidateTime(params).then((scheduleValidateTime) => {
            commit('SET_SCHEDULE_VALIDATE_TIME', scheduleValidateTime);
        });
    },
    scheduleMariaPro({commit, dispatch}, params) {
        return service.scheduleMariaPro(params)
            .then(({scheduleMariaPro}) => {
                commit('SET_SCHEDULE_MARIA_PRO', scheduleMariaPro);
            });
    },
    schedulePageMariaPro({commit, dispatch}, params) {
        return service.schedulePageMariaPro(params)
            .then(({schedulePageMariaPro}) => {
                commit('SET_SCHEDULE_PAGE_MARIA_PRO', schedulePageMariaPro);
            });
    },
    scheduleAdminMariaPro({commit, dispatch}, params) {
        return service.scheduleAdminMariaPro(params).then((scheduleAdminMariaPro) => {
            commit('SET_SCHEDULE_ADMIN_MARIA_PRO', scheduleAdminMariaPro);
        });
    },
    scheduleAdminPageMariaPro({commit, dispatch}, params) {
        return service.scheduleAdminPageMariaPro(params).then((scheduleAdminPageMariaPro) => {
            commit('SET_SCHEDULE_ADMIN_PAGE_MARIA_PRO', scheduleAdminPageMariaPro);
        });
    },
    scheduleUpdateMariaPro({commit, dispatch}, params) {
        return service.scheduleUpdateMariaPro(params).then((scheduleUpdateMariaPro) => {
            commit('SET_SCHEDULE_UPDATE_MARIA_PRO', scheduleUpdateMariaPro);
        });
    },
    scheduleMassSubscribeMariaPro({commit, dispatch}, params) {
        return service.scheduleMassSubscribeMariaPro(params).then((scheduleMassSubscribeMariaPro) => {
            commit('SET_SCHEDULE_MASS_SUBSCRIBE_MARIA_PRO', scheduleMassSubscribeMariaPro);
        });
    },
    scheduleRetoucherSignUpNow({commit, dispatch}, params) {
        return service.scheduleRetoucherSignUpNow(params).then((scheduleRetoucherSignUpNow) => {
            commit('SET_SCHEDULE_RETOUCHER_SIGN_UP_NOW', scheduleRetoucherSignUpNow);
        });
    },
    scheduleMinuteEmploymentMariaPro({commit, dispatch}, params) {
        return service.scheduleMinuteEmploymentPro(params).then((scheduleMinuteEmploymentPro) => {
            commit('SET_SCHEDULE_MINUTE_EMPLOYMENT_MARIA_PRO', scheduleMinuteEmploymentPro);
        });
    },

};

const getters = {
    schedule: state => state.schedule,
    schedulePage: state => state.schedulePage,
    usersList: state => state.usersList,
    scheduleAdmin: state => state.scheduleAdmin,
    scheduleAdminPage: state => state.scheduleAdminPage,
    scheduleUpdate: state => state.scheduleUpdate,
    scheduleMaria: state => getterKey => state.scheduleMaria,
    scheduleMariaTime: state => getterKey => state.scheduleMariaTime,
    schedulePageMaria: state => getterKey => state.schedulePageMaria,
    schedulePageMariaTime: state => getterKey => state.schedulePageMariaTime,
    scheduleAdminMaria: state => getterKey => state.scheduleAdminMaria,
    scheduleAdminPageMaria: state => getterKey => state.scheduleAdminPageMaria,
    scheduleUpdateMaria: state => getterKey => state.scheduleUpdateMaria,
    scheduleRetoucherSignUpNow: state => getterKey => state.scheduleRetoucherSignUpNow,
    scheduleMariaPro: state => getterKey => state.scheduleMariaPro,
    schedulePageMariaPro: state => getterKey => state.schedulePageMariaPro,
    scheduleAdminMariaPro: state => getterKey => state.scheduleAdminMariaPro,
    scheduleAdminPageMariaPro: state => getterKey => state.scheduleAdminPageMariaPro,
    scheduleUpdateMariaPro: state => getterKey => state.scheduleUpdateMariaPro,
    scheduleValidateTime: state => getterKey => state.scheduleValidateTime,
    scheduleMinuteEmploymentMariaPro: state => getterKey => state.scheduleMinuteEmploymentMariaPro,
    scheduleMassSubscribeMariaPro: state => getterKey => state.scheduleMassSubscribeMariaPro
};

const schedule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default schedule;